/* The i18n library needs a flattened key structure
which causes us to have to do a lot of copy and
pasting. This code takes a JSON object and creates
the flattened code required. */

const flattenTranslationKeys = (nestedTranslations, dict = {}, prefix = '') => {
  return Object.keys(nestedTranslations).reduce((acc, key) => {
    const newKey = prefix ? `${prefix}.${key}` : key
    const value = nestedTranslations[key]
    if (typeof value === 'string') {
      acc[newKey] = value
    } else {
      flattenTranslationKeys(value, acc, newKey)
    }
    return acc
  }, dict)
}

const flattenTranslationFile = (translationFile) => {
  return Object.keys(translationFile).reduce((acc, key) => {
    acc[key] = flattenTranslationKeys(translationFile[key])
    return acc
  }, {})
}

export { flattenTranslationFile }
